import { Alert } from "@mui/material";
import { BeneficialOwnersContent } from "Components/Shared/Merchant/BeneficialOwners/BeneficialOwnersContent";
import { ValuesBox } from "Components/Shared/ValuesBox/ValuesBox";
import { type RelatedPartyDto, RelationType } from "Infrastructure/Api/Api";
import { Resources, useResource } from "Translations/Resources";

type Props = {
  owningPartyID: string;
  relatedParties: Array<RelatedPartyDto>;
  isUboUnknown: boolean;
};

export const BeneficialOwnersSection = ({
  owningPartyID,
  relatedParties,
  isUboUnknown,
}: Props) => {
  const { t } = useResource();

  const relatedOwnerPartyIDs = relatedParties
    .filter(({ relationType }) => relationType === RelationType.BeneficialOwner)
    .map(({ relatedPartyPublicID }) => relatedPartyPublicID);

  return (
    <ValuesBox title={t(Resources.AML.BeneficialOwners)}>
      {isUboUnknown && (
        <Alert severity="warning">{t(Resources.AML.UboUnknownAlert)}</Alert>
      )}
      <BeneficialOwnersContent
        isReadOnly
        owningPartyID={owningPartyID}
        relatedPartiesIDs={relatedOwnerPartyIDs}
      />
    </ValuesBox>
  );
};
